var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreyDelete = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group",
  xmlns: "http://www.w3.org/2000/svg",
  width: 22.052,
  height: 24.366,
  viewBox: "0 0 22.052 24.366",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M51.294,16.68a.964.964,0,0,0,.964-.964.932.932,0,0,0-.964-.964H43.515a.932.932,0,0,0-.964.964.964.964,0,0,0,.964.964Z",
  transform: "translate(-36.379 -14.751)",
  fill: "#999"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M49.734,61.145a1,1,0,0,0,.964-.964V53.269a.964.964,0,0,0-.964-.964.932.932,0,0,0-.964.964v6.911A.964.964,0,0,0,49.734,61.145Z",
  transform: "translate(-40.957 -42.404)",
  fill: "#999"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M66.8,61.145a.964.964,0,0,0,.964-.964V53.269a.932.932,0,0,0-.964-.964.964.964,0,0,0-.964.964v6.911a1,1,0,0,0,.964.964Z",
  transform: "translate(-53.529 -42.404)",
  fill: "#999"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "Compound_Path",
  "data-name": "Compound Path",
  d: "M40.228,30.846H20.105a.932.932,0,0,0-.964.964.964.964,0,0,0,.964.964h1.447v15.3a2.893,2.893,0,0,0,2.893,2.893H35.888a2.893,2.893,0,0,0,2.893-2.893v-15.3h1.447a.964.964,0,0,0,.964-.964.932.932,0,0,0-.964-.964Zm-3.375,17.23a.932.932,0,0,1-.964.964H24.445a.932.932,0,0,1-.964-.964v-15.3H36.853Z",
  transform: "translate(-19.14 -26.602)",
  fill: "#999"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreyDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grey_delete.2c1bdd06d591b7f18d27efe0e65c07e0.svg";